import React from 'react';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { createMuiTheme } from '@material-ui/core';
import { ThemeProvider } from "@material-ui/styles";

import { themes } from '../../../constants/styles';
import { company } from '../../../utils/brand';

import { timeFormat } from '../../../constants/time';

const mainTheme = createMuiTheme({
  ...themes[company],
  typography: {
    fontSize: 16,
  },
});

const datePickerOverrides = createMuiTheme({
  overrides: {

    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: mainTheme.palette.secondary.main,

        '& h6': {
          color: mainTheme.palette.primary.main,
        },

        '& h4': {
          color: mainTheme.palette.primary.main,
        }
      }
    },
    MuiPickersDay: {
      day: {
        color: mainTheme.palette.text.primary,
      },
      daySelected: {
        backgroundColor: mainTheme.palette.secondary.light,

        '&:hover': {
          backgroundColor: mainTheme.palette.secondary.main,
        },
      },
      current: {
        color: mainTheme.palette.secondary.main,

        '&.isSelected': {
          color: mainTheme.palette.primary.main,
        }
      },
    },
    MuiDialogActions: {
      spacing: {
        '& span': {
          color: mainTheme.palette.secondary.main,
        },
      },
    },
  }
})

export const WrappedDatePicker = ({ onChange, value, t, ...rest }) =>
  <ThemeProvider theme={datePickerOverrides}>
    <KeyboardDatePicker
      format={timeFormat.DATE}
      onChange={onChange}
      value={value ? new Date(value) : null}
      cancelLabel={t.cancelLabel}
      okLabel={t.okLabel}
      maxDateMessage={t.maxDateMessage}
      minDateMessage={t.minDateMessage}
      invalidDateMessage={t.invalidDateMessage}
      {...rest}
    />
  </ThemeProvider>



// WEBPACK FOOTER //
// ./src/components/base/DatePicker/DatePicker.js